import { Button, Card, Textarea } from "@altimateai/lego";
import { useChatContext } from "../../chatbotV2/ChatProvider";
import { useAgentChat } from "../../chatbotV2/hooks/useAgentChat";
import { useState } from "react";
import { addMessage } from "../../chatbotV2/store/chatSlice";

const HelloMessage = () => {
  const { sessions, currentSessionId, dispatch } = useChatContext();
  const { updateContextAndSendMessage } = useAgentChat();
  const [textValue, setTextValue] = useState("");
  const handleSubmit = async () => {
    dispatch(
      addMessage({
        sessionId: currentSessionId!,
        id: Date.now().toString(),
        content: `##### Migrating your query:\n\`\`\`\n${textValue}\n\`\`\``,
        role: "user",
        timestamp: Date.now(),
        heading: "",
      })
    );
    await updateContextAndSendMessage("Migrate the query", {
      query: textValue,
    });
  };

  const context = currentSessionId ? sessions[currentSessionId]?.context : {};

  return (
    <div>
      Hello, I am your Teradata to Snowflake migration assistant.
      {!context?.query ? (
        <Card className="al-bg-muted al-p-4 al-rounded-md al-shadow-md al-space-y-2 al-mt-2">
          <p>
            Please enter a query below or select a file using Add Context button to start the
            migration.
          </p>
          <Textarea
            value={textValue}
            onChange={e => setTextValue(e.target.value)}
            placeholder="Please enter a query"
            required={true}
          />
          <Button onClick={handleSubmit}>Submit</Button>
        </Card>
      ) : null}
    </div>
  );
};

export default HelloMessage;
